
import InputBar from '../InputBar/InputBar'
import { useSelector } from 'react-redux'

const InputContainer = () => {
  const { name, email, phone } = useSelector(
    (state) => state.PersonalInfo
  )

  const { nameError, emailError, phoneError } = useSelector(
    (state) => state.error
  )

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '10px',
       
      }}
    >
      <InputBar value={name} label="Name" error={nameError} />
      <InputBar value={email} label="Email" error={emailError} />
      <InputBar value={phone} label="Phone" error={phoneError} />
    </div>
  )
}

export default InputContainer